import { Link, Redirect } from "react-router-dom";
import Navbar from "../components/layout/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getAddress } from "../store/actions/productAction";

const ThankYou = () => {
  const dispatch = useDispatch();

  const address = useSelector((state) => state.product.address);

  useEffect(() => dispatch(getAddress()), []);
  return (
    <div id="thank-you">
      <Navbar />
      {address.length === 0 ? (
        <Redirect to="/products" />
      ) : (
        <div className="container">
          <div className="row justify-content-center align-items-center h-80vh">
            <div className="col-lg-6 col-sm-12">
              <div className="card bg-secondary" style={{ height: "300px" }}>
                <h2 className="card-title text-center mt-5">
                  It's Ordered
                  <i
                    className="fa fa-shopping-cart me-2"
                    aria-hidden="true"
                  ></i>
                </h2>
                <p className="text-center text-light mt-3">
                  You will receive an invoice for your order shortly. Your order
                  will arrive in 7 business days.
                </p>
                <div className="d-flex justify-content-center align-items-center">
                  <Link to="/products">
                    <button className="btn btn-primary mt-3">
                      Browse for more product
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ThankYou;
